<template>
  <div class="pie">
    <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
    <div id="main1"
         ref="main"
         style="float:left;width:100%;height: 100px"></div>
  </div>
</template>
 
<script>
var echarts = require('echarts');

export default {
  props: ['dataList', 'isSpecial'],
  data () {
    return {
      // 数据
      dom: null,
    }
  },
  computed: {
    options () {
      let that = this;
      let option = {
        color: ['#4F8CFA', '#FFC16C'],
        // tooltip: {
        //   trigger: 'item',
        //   formatter: "{a} <br/>{b}: {c} ({d}%)"
        // },
        series: [
          {
            name: '多头借贷',
            type: 'pie',
            radius: ['50%', '70%'],//修改饼图的粗细
            center: ['45%', '55%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              // emphasis: {
              //   show: false,
              //   textStyle: {
              //     fontSize: '30',
              //     fontWeight: 'bold'
              //   }
              // }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: []
          }
        ]
      }
      return option;

    }
  },
  mounted () {
    this.initData();
    window.addEventListener('resize', this.options)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.options)
  },
  watch: {
    dataList: {
      handler (newVal, oldVal) {
        this.initData();
      },
      deep: true
    }
  },
  methods: {
    resize () {
      this.dom.resize();
    },
    //初始化数据
    initData () {
      var myChart = echarts.init(document.getElementById('main1'));
      if (this.isSpecial == 1) {
        this.options.color = ['#0078FF', '#8EE1FF']
      }
      this.options.series[0].data = this.dataList;
      // 绘制图表
      myChart.setOption(this.options);
    },
  }
}
</script>